//import { Tracker } from 'meteor/tracker';
import SimpleSchema from 'simpl-schema';
import phoneSchema from 'src/schemas/phone';

const schema = new SimpleSchema({
  firstName: {
    type: String,
    min: 1,
    label: 'First',
  },
  lastName: {
    type: String,
    min: 1,
    label: 'Last',
  },
  pronoun: {
    type: String,
    min: 1,
    label: 'Pronouns',
  },
  title: {
    type: String,
    min: 1,
    label: 'Title',
  },
  email: {
    type: String,
    regEx: SimpleSchema.RegEx.Email,
    label: 'Email',
  },
  office: {
    type: String,
    min: 1,
    label: 'Office',
  },
  meetingLink: {
    type: String,
    // min: 1,
    label: 'Meeting Link',
    optional: true,
  },
  phones: {
    type: Array,
    optional: true,
  },
  'phones.$': {
    type: phoneSchema,
    optional: true,
  },
  socials: {
    type: Array,
    optional: true,
  },
  'socials.$': {
    type: String,
    min: 1,
    optional: true,
  },
});

export default schema;
